<div mat-dialog-title>
  <h2>{{header | translate}}</h2>
  <button class="close"
    (click)="cancel()"
    aria-label="Close dialog">
    <mat-icon svgIcon="cross"></mat-icon>
  </button>
</div>
<label>{{'generic.required_fields' | translate}}</label>
<form novalidate (ngSubmit)="validate()">
  <div mat-dialog-content>
    @if (body) {
      <div>{{body}}</div>
    }
    @if (askTitle) {
      <mat-form-field>
        <mat-label>{{'cards.assignment_modal_ask_title' | translate}}</mat-label>
        <input matInput name="title" [(ngModel)]="title" type="text">
      </mat-form-field>
    }

    <mat-chip-set>
      @for (group of selectedGroupList$ | async; track group) {
        <mat-chip
          [disabled]="isUserEditAssignment"
          (removed)="removeGroup(group)"
          >
          {{ group.label }}
          <mat-icon matChipRemove svgIcon="cross"></mat-icon>
        </mat-chip>
      }
    </mat-chip-set>

    <mat-form-field floatLabel="auto">
      <mat-label>{{ 'corpus.share_to_groups_input_placeholder' | translate }}</mat-label>
      <input
        [disabled]="isUserEditAssignment"
        [required]="!isUserEditAssignment"
        type="text"
        matInput
        [matAutocomplete]="auto"
        />
        <mat-icon matSuffix>search</mat-icon>
        <mat-hint>{{ 'cards.create_class_before_starting_lesson_hint' | translate }}</mat-hint>

        <mat-autocomplete
          [displayWith]="displayFn"
          (optionSelected)="selectGroup($event)"
          autoActiveFirstOption
          #auto="matAutocomplete"
          >
          @for (group of groupList$ | async; track group) {
            <mat-option appAriaTitle [value]="group">
              {{ group.label }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      @if (askNumberOfViewers) {
          <mat-form-field floatLabel="auto">
              <mat-label>{{'cards.assignment_modal_ask_number_of_viewers' | translate}}</mat-label>
              <input
                  matInput
                  name="numberOfViewers"
                  [(ngModel)]="numberOfViewers"
                  type="number"
                  min="0"
                  step="1"
                  required
              />
          </mat-form-field>
      }
    </div>

    <div mat-dialog-actions>
      <button [disabled]="disableValidateBtn()"
        (click)="validate()" mat-raised-button
      class="mat-accent mr-16">{{validLabel | translate}}</button>
    </div>
  </form>